export default {
  en: {
    errorMessages: {
      form_validation: 'Form is invalid, please correct all error before submitting.',
      no_connection: 'Cannot connect to server. Please check your network connection and try again.',
      c401: 'Please enter valid email/mobile number and password.',
      c404: 'Data not found',
      c429: 'You has sent too many requests in a given amount of time. Please try again later.',
      c409: 'Error data conflict',
      c500: 'Something went wrong on our servers.',
      common: 'Handle error later !',
    },
  },
  th: {
    errorMessages: {
      form_validation: 'มีข้อผิดพลาดในฟอร์มด้านบน กรุณากลับไปแก้ไขแล้วลองอีกครั้ง',
      no_connection: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ กรุณาตรวจสอบการเชื่อมต่ออินเตอร์เน็ตของคุณแล้วลองอีกครั้ง',
      c401: 'กรุณากรอกอีเมลหรือเบอร์โทรศัพท์และรหัสผ่านให้ถูกต้อง',
      c404: 'ไม่พบข้อมูลที่คุณต้องการ',
      c429: 'คุณส่งคำขอมากเกินกว่าที่กำหนด กรุณารอซักครู่และลองใหม่อีกครั้ง',
      c409: 'เกิดข้อผิดพลาดเนื่องจากมีข้อมูลซ้ำ',
      c500: 'ขออภัย เกิดข้อผิดพลาดในเซิร์ฟเวอร์',
      common: 'เกิดข้อผิดพลาด',
    },
  },
};
